import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { VocabWordDetailsWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import Tabs from 'components/tabs';
import ConjugationTable from 'components/conjugation_table';
import TranslationComments from 'components/comment/translation_comments';
import Button from 'components/button/button';
import Spinner from 'components/spinner';
import VocabLabels from 'components/vocab/vocab_labels';
import VocabWordInfoList from 'components/vocab/vocab_word_info_list';
import DictionarySentences from 'components/vocab/dictionary_sentences';
import VocabTriad from 'components/sentence/vocab_triad';
import VocabWordConcepts from 'components/vocab/vocab_word_concepts';
import RelatedWords from 'components/vocab/related_words';
import SentenceSubmissionIndex from 'components/sentence_submission/sentence_submission_index';

const InsetTabContent = styled.div`
  margin: 0 10px;
`;

@observer
class VocabWordDetails extends React.Component {
  @computed get showGrammarTab() {
    return this.props.hasGrammarContent && !this.props.inDeck;
  }

  @computed get dictionaryTabs() {
    return [
      { name: 'meanings', label: this.props.dictionaryTabLabel },
      ...this.props.tabs.filter(tab => tab.name === 'comments'),
      ...this.props.tabs.filter(tab => tab.name === 'conjugations').map(tab => ({ ...tab, label: 'Conjugations' })),
      ...(this.props.word.vocabTriadConceptId ? [{ name: 'story', label: 'Story' }] : []),
      ...(this.props.hasRelatedContent ? [{ name: 'relatedWords', label: 'Related Words' }] : []),
      ...(this.showGrammarTab ? [{ name: 'grammar', label: 'Grammar' }] : []),
    ];
  }

  render() {
    if (!this.props.word) return null;
    return (
              <Tabs
                margin={`${this.props.tabMarginTop || 0}px 0 0`}
                keepMounted
                key={this.props.word.id}
                showTabsWhileLoading
                loading={this.props.showSpinner}
                tabs={this.dictionaryTabs}
                tabPadding='10px'
                contentPadding='0'
                fontSize={AppUI.layout.isMobile ? '11px' : '13px'}
              >
                <div>
                  <VocabWordInfoList
                    {...this.props}
                    afterFlag={this.props.getWord}
                    rowMargin={this.props.rowMargin}
                    hideHeader
                    hideRelatedWords
                    margin='0'
                    tablePadding='0'
                    dictionaryMeanings
                    onPlaySentence={this.props.onPlaySentence}
                  />
                  {this.props.word.id && (this.props.showOrganisedTranslations && AppUI.user?.admin) &&
                    <div>
                      <DictionarySentences
                        key={this.props.word.id}
                        wordId={this.props.word.id}
                        onPlaySentence={this.props.onPlaySentence}
                        title='Other Sentences'
                        hideSkeleton
                        adminOnly
                      />
                    </div>
                  }

                  {
                    !this.props.inDeck && this.props.word &&
                    <VocabLabels word={this.props.word} showFrequencyWithProgress />
                  }
                  {this.props.showSentenceSubmissions && this.props.word.id && <SentenceSubmissionIndex wordId={this.props.word.id} expandSentenceSubmissionCreate />}
                </div>
                <TranslationComments
                  expanded
                  word={this.props.word}
                  loadOnMount
                  wordId={this.props.word.id}
                  hideTitle
                  padding='0'
                  commentLayout='forum'
                  forumPadding={AppUI.layout.isMobile ? '10px' : null}
                  indentation={AppUI.layout.isMobile ? 20 : null}
                />
                {
                  this.props.showConjugationsTab &&
                  <div>
                    {this.props.conjugationsError ? (
                      <Button onClick={this.props.getConjugations}>Retry Loading Conjugations</Button>
                    ) : !this.props.verbConjugationsLoaded ? (
                      <Spinner margin="30px auto" />
                    ) : (
                      <ConjugationTable
                        inDeck={this.props.inDeck}
                        hideHeader
                        blockUnmount
                        expand
                        word={this.props.word}
                        conjugatedVerbStrings={this.props.conjugatedVerbStringStore?.indexData}
                        labelMargin="0"
                      />
                    )}
                  </div>
                }
                {this.props.word.vocabTriadConceptId && (active => <VocabTriad plain isTabActive={active} word={this.props.word} />)}
                {this.props.hasRelatedContent &&
                  <div>
                    <RelatedWords
                      inDeck={this.props.inDeck}
                      rows
                      margin='0'
                      referenceWord={this.props.word}
                      words={this.props.relatedEntries}
                      onClickWord={this.props.onClickWord}
                    />
                  </div>
                }
                {
                  this.showGrammarTab &&
                  <InsetTabContent>
                    <VocabWordConcepts
                      inline
                      word={this.props.word}
                      expandedId={this.props.expandedId}
                      onClickRow={this.props.onClickRow}
                      rowMargin={this.props.rowMargin}
                    />
                  </InsetTabContent>
                }
              </Tabs>
    );
  }
}

export default VocabWordDetailsWrapper(VocabWordDetails);
